import { isString as t, isArray as n, isObject as i } from "./index575.js";
import { isDate as y, isFunction as N, isPlainObject as d, isPromise as g } from "./index575.js";
const r = (e) => e === void 0, o = (e) => typeof e == "boolean", m = (e) => typeof e == "number", f = (e) => !e && e !== 0 || n(e) && e.length === 0 || i(e) && !Object.keys(e).length, c = (e) => typeof Element > "u" ? !1 : e instanceof Element, u = (e) => t(e) ? !Number.isNaN(Number(e)) : !1;
export {
  n as isArray,
  o as isBoolean,
  y as isDate,
  c as isElement,
  f as isEmpty,
  N as isFunction,
  m as isNumber,
  i as isObject,
  d as isPlainObject,
  g as isPromise,
  t as isString,
  u as isStringNumber,
  r as isUndefined
};
